import OrderSortFilter from "../symbols/orderSortFilter";

const initialState = {
  data: {
    filter: { 0: { Status: [] }, 1: { Status: [] }, 2: { Status: [] } },
    query: { 0: '', 1: '', 2: '' },
    orderBy: 'desc',
  }
};

function OrderSortFilterReducer(state = initialState, action: any) {
  switch (action.type) {
    case OrderSortFilter.SET_ORDER_SORT_FILTER:
      return {
        ...state,
        data: {
          filter: action.payload.filter,
          orderBy: action.payload.orderBy,
          query: action.payload.query
        }
      };
    case OrderSortFilter.CLEAR_ORDER_SORT_FILTER:
      return {
        ...state,
        data: {
          filter: { Status: [] },
          orderBy: 'desc',
          query: '',
        }
      };

    default:
      return state;
  }
}
export default OrderSortFilterReducer;
